const Role = {
  mmpladmin: "admin",
  client: "client",
  mmpl: "mmpl",
  staff: "staff",
  approver : "approver"
};
export default Role;
